import { render, staticRenderFns } from "./BldIco.vue?vue&type=template&id=bef734b2&scoped=true&"
import script from "./BldIco.vue?vue&type=script&lang=js&"
export * from "./BldIco.vue?vue&type=script&lang=js&"
import style0 from "./BldIco.vue?vue&type=style&index=0&id=bef734b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef734b2",
  null
  
)

export default component.exports